<script setup lang="ts">
const props = defineProps<{ title: string, extraClass: string }>();
</script>

<template>
  <div :class="['container-block','container-label',props.extraClass]">
    <span v-if="props.title">{{ props.title }}</span>
  </div>
</template>

<style scoped>
.container-label {
  height: 19px;
  margin: 0 26px 8px 7px;
  font-family: WorkSans;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 0.25px;
  text-align: left;
  color: var(--container-label-colour);
}
</style>